"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPayeesAsList = exports.getPayeesForAccounts = exports.getPayeesNameList = exports.getPayeeTransactionsById = exports.getPayeesStore = exports.getLoadPending = void 0;
const re_reselect_1 = require("re-reselect");
const reselect_1 = require("reselect");
const luxon_1 = require("luxon");
const immutable_1 = require("immutable");
const core_1 = require("companion-app-components/flux/core");
const accounts_1 = require("companion-app-components/flux/accounts");
const config_feature_flags_1 = require("companion-app-components/flux/config-feature-flags");
const core_2 = require("companion-app-components/utils/core");
const auth_1 = require("companion-app-components/flux/auth");
const transactions_1 = require("companion-app-components/flux/transactions");
const selectors_1 = require("data/transactions/selectors");
const memorizedRulesSelectors_1 = require("companion-app-components/flux/memorized-rules/memorizedRulesSelectors");
const searchFilter_1 = require("data/transactions/searchFilter");
const clientConfigFlags_1 = require("utils/clientConfigFlags");
const selectors_2 = require("data/preferences/selectors");
const reducer_1 = require("./reducer");
const utils_1 = require("./utils");
const log = (0, core_2.getLogger)('data/payees/selectors');
const getLoadPending = (state) => accounts_1.accountsSelectors.getLoadPending(state) || (0, selectors_1.getLoadPending)(state);
exports.getLoadPending = getLoadPending;
const getPayeesStore = (state) => state[reducer_1.REDUCER_KEY];
exports.getPayeesStore = getPayeesStore;
const getPayeeTransactionsById = (state) => {
    const newState = (0, exports.getPayeesStore)(state);
    return newState.payeesByAccountId;
};
exports.getPayeeTransactionsById = getPayeeTransactionsById;
exports.getPayeesNameList = (0, reselect_1.createSelector)(exports.getPayeeTransactionsById, (payeesById) => {
    let ret = null;
    const payeeNames = (0, immutable_1.Map)().withMutations((map) => {
        payeesById.forEach((account) => account.forEach((payee) => {
            const existing = map.get(payee.name);
            map.set(payee.name, { id: payee.id, name: payee.name, count: payee.count + ((existing === null || existing === void 0 ? void 0 : existing.count) || 0) });
        }));
        return map;
    });
    if (payeeNames) {
        ret = (0, immutable_1.List)(payeeNames.toList().toJS()).sort((payee1, payee2) => payee2.count - payee1.count);
    }
    return ret;
});
/**
 * Get payee data for the requested account node
 */
exports.getPayeesForAccounts = (0, re_reselect_1.createCachedSelector)((state) => ({
    obj: (0, exports.getPayeeTransactionsById)(state),
    deep: false,
}), (state) => ({
    obj: accounts_1.accountsSelectors.getAccountsById(state),
    deep: false,
}), (state, props) => ({
    obj: props && props.accountIds && props.accountIds.size > 0 ? props.accountIds.sort() : undefined,
    deep: true,
}), ({ obj: payeeTransactionsById }, { obj: accountsById }, { obj: accountIds }) => {
    log.log('Selector - Getting Payees for ', accountIds);
    let payeeList = (0, immutable_1.Map)();
    let accounts = accountIds;
    if (!accountIds) {
        accounts = accountsById.map((x) => x.id);
    }
    accounts.forEach((accountId) => {
        const pList = payeeTransactionsById.get(accountId);
        if (pList) {
            payeeList = payeeList.mergeWith((payee1, payee2) => { var _a, _b; return luxon_1.DateTime.fromISO((_a = payee2.txn) === null || _a === void 0 ? void 0 : _a.postedOn) >= luxon_1.DateTime.fromISO((_b = payee1.txn) === null || _b === void 0 ? void 0 : _b.postedOn) ? payee2 : payee1; }, pList);
        }
    });
    // Now we trim the payee list down if it is too large based on dates
    payeeList = payeeList.sort((payee1, payee2) => { var _a, _b; return luxon_1.DateTime.fromISO((_a = payee2.txn) === null || _a === void 0 ? void 0 : _a.postedOn).toSeconds() - luxon_1.DateTime.fromISO((_b = payee1.txn) === null || _b === void 0 ? void 0 : _b.postedOn).toSeconds(); });
    // Now we sort it by payee name so the list is alphabetized
    payeeList = payeeList.take(150).sort((payee1, payee2) => {
        if (payee1.name > payee2.name) {
            return 1;
        }
        if (payee1.name < payee2.name) {
            return -1;
        }
        return 0;
    });
    return payeeList;
})({
    keySelector: (_state, props) => `${JSON.stringify(props && props.accountIds && props.accountIds.size > 0 ? props.accountIds.sort() : undefined)}`,
    cacheObject: new re_reselect_1.LruObjectCache({ cacheSize: 5 }),
    selectorCreator: core_1.selectorsHelpers.createFlexEqualSelector,
});
exports.getPayeesAsList = (0, reselect_1.createSelector)((state, props) => (0, exports.getPayeesForAccounts)(state, props), (state) => (0, memorizedRulesSelectors_1.getMemorizedRulesById)(state), (state) => config_feature_flags_1.configFeatureFlagsSelectors.getFeatureFlagForUserOrDataset(state, clientConfigFlags_1.ClientConfigFlags.memorizedPayeeAutoPopulate), (state) => (0, selectors_2.isApplyMemorizedRulesEnabled)(state), (state) => auth_1.authSelectors.getIsWinDataset(state), (payeesForAccounts, memorizedPayees, memorizedPayeeAutoPopulate, applyMemorizedRules, isQWinDataset) => {
    var _a;
    const txnPayeeList = (_a = payeesForAccounts === null || payeesForAccounts === void 0 ? void 0 : payeesForAccounts.toList()) !== null && _a !== void 0 ? _a : (0, immutable_1.List)();
    // add memorized payee to payee list & remove redendant payee from txns list
    const addMemorizedPayees = () => {
        const memorizedPayeeList = memorizedPayees.valueSeq().toArray().map((memPayee) => {
            const { coa, split } = memPayee;
            const newSplitItems = split === null || split === void 0 ? void 0 : split.items.map((item) => (Object.assign(Object.assign({}, item), { id: null })));
            const txn = Object.assign({ coa, tags: memPayee.tags, amount: memPayee.amount, memo: memPayee.memo }, (newSplitItems ? { split: transactions_1.transactionsTransformers.mkSplit({ items: newSplitItems }) } : {}));
            const pRule = {
                id: memPayee.id,
                name: memPayee.payee,
                amountString: memPayee.amount,
                catString: transactions_1.transactionsUtils.isSplitTxn(txn) ? (0, utils_1.getSplitCategoryNames)(txn) : (0, searchFilter_1.getFieldString)('category', txn, undefined),
                showSplitIcon: (newSplitItems === null || newSplitItems === void 0 ? void 0 : newSplitItems.length) > 1,
                isAmountBasedRule: Boolean(memPayee.amountCondition),
                isMemorizedPayee: true,
                markAsCleared: memPayee.markAsCleared,
                txn,
            };
            return (0, immutable_1.Record)(pRule)(pRule);
        });
        if (isQWinDataset) {
            return memorizedPayeeList;
        }
        const memorizedNamesSet = new Set(memorizedPayeeList.map((payee) => payee.name));
        const filteredTxnPayees = txnPayeeList
            .filter((payee) => !memorizedNamesSet.has(payee.name))
            .toArray();
        return [...memorizedPayeeList, ...filteredTxnPayees];
    };
    // Enable memorized payee auto-populate for QWIN only if quick fill enabled
    return memorizedPayeeAutoPopulate && ((isQWinDataset && applyMemorizedRules) || !isQWinDataset) ? addMemorizedPayees() : txnPayeeList;
});
